import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';

const DatePicker = (props) => {
  const dateValue = props.value;
  const getDate = props.getDate;
  const size = props.size;
  const color = props.color;
  const dateLabel = props.dateLabel;
  const defaultDate = props.defaultDate; //'2014-08-18T21:11:54'
  const [value, setValue] = useState(dayjs(defaultDate));

  const handleChange = (newValue) => {
    let dateString = new Date(newValue?.$d).toLocaleString();

    const formattedDate = dateString
      .replace(/\//g, '-')
      .replace(/\s/g, 'T')
      .replace(/,/g, '');

    let mtesting = `${newValue?.$y}-${padLeft(newValue?.$M + 1)}-${padLeft(
      newValue?.$D
    )}`;

    setValue(mtesting);
    getDate(mtesting);
  };

  const padLeft = (intVal) => {
    return intVal < 10 ? `0${intVal}` : intVal;
  };

  return (
    <div
      style={{
        // margin: '10px 0',
        background: '#fff',
        // height: '36px',
        borderRadius: '5px',
        // padding: '0px',
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          sx={{ borderRadius: '5px' }}
          label={dateLabel}
          size='small'
          inputFormat='DD/MM/YYYY'
          padding='5px'
          value={defaultDate}
          onChange={handleChange}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{ background: '#fff' }}
              fullWidth
              size='small'
            />
          )}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DatePicker;
